const ID_FRECUENCIA_NUNCA = 1

class GetReactivos {
  #repository

  constructor(repository) {
    this.#repository = repository
  }

  async execute(tipoEvaluacion) {
    const reactivos = await this.#repository.getReactivos(tipoEvaluacion)

    return reactivos.map((reactivo) => ({
      id: reactivo.id,
      descripcion: reactivo.CatDescripcion?.title ?? '',
      idRubro: reactivo.fk_idCatCriterioEvaluacion,
      calificacion: ID_FRECUENCIA_NUNCA,
    }))
  }
}

export default GetReactivos
